import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';

// SERVER-ONLY URL rewrite for SSR.
//
// On the server, Angular's platform-server resolves relative HttpClient URLs
// (e.g. '/api/datefirma/companies/:cui') to an absolute URL using the origin
// derived from the incoming request headers. Because src/server.ts trusts
// x-forwarded-host / x-forwarded-proto (Traefik → Cloudflare), that origin is
// the PUBLIC site (https://datefirma.ro). The SSR fetch would then round-trip
// back OUT through Cloudflare instead of reaching the BFF that lives in the same
// Express process — it gets challenged / times out, the company fetch fails, and
// the page serializes with no data (generic <title>, empty company shell).
//
// Pinning /api calls to the in-container BFF over loopback keeps the request
// inside the process so SSR gets real data. Making the URL absolute here (before
// platform-server's relative-URL transformer runs) means that transformer leaves
// it untouched. In the browser this is a no-op: requests stay relative.
export const ssrApiInterceptor: HttpInterceptorFn = (req, next) => {
  if (isPlatformServer(inject(PLATFORM_ID)) && req.url.startsWith('/api')) {
    // 127.0.0.1 (not 'localhost') avoids IPv6 happy-eyeballs ECONNREFUSED on
    // node-alpine when nothing is listening on ::1. PORT must match the port the
    // Express server actually binds (src/server.ts: process.env['PORT'] || 4000).
    const port = (typeof process !== 'undefined' && process.env['PORT']) || 4000;
    req = req.clone({ url: `http://127.0.0.1:${port}${req.url}` });
  }
  return next(req);
};
